
import DetailsPageHeader from '../../components/DetailsPageHeader';
import { ReactComponent as DotIcon} from '../../components/svgs/activeDotIcon.svg';
import ManagerSidebar from '../../components/manager/ManagerSidebar';
import EmployeesDetailsTab from '../../components/manager/EmployeesDetailsTab';


const EmployeesDetailsScreen = () => {


  return (
    <>
        <section className='dashboard-container flex '>
        <aside className=''>
            <ManagerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <DetailsPageHeader pageName={'Employees'} customerDetails={'Micheal Scott'} showEmployeesButton={true}/>
            <section className='mt-10 flex gap-5'>
                <div className=''>
                    <div className='laundry-details-title-items gap-10'>
                        <div className='employee-initials-border'>
                            <p className='employee-initials'>MS</p>
                        </div>
                        <div className='flex flex-col gap-2'>
                            <p className='order-id'>Micheal Scott</p>
                            <div className='flex gap-4 employee-role-border'>
                                <p className='employee-role'>Attendant</p>
                                
                            </div>
                            
                        </div>
                        <section className='active-more-options flex gap-10'>
                            <div className='flex gap-4 mt-3.5'>
                                <DotIcon className='mt-6'/>
                                <p className='employee-active'>Active</p>
                                
                            </div>
                            
                            <div className='order-status-option-dropdown'>
                                
                                <select className='mt-6'>
                                    <option value="option1">More options</option>
                                    <option value="option2">Edit employee</option>
                                    <option value="option3">Archive employee</option>
                                  
                                </select>
                            
                            </div>
                        </section>
                        
                    </div>
                    
                </div>
               
            </section>
            <section className='mt-20 flex gap-4'>
                <section>
                    <EmployeesDetailsTab/>
            </section>
            {/* <section className='side-card-section'>
              <SideCard/>
            </section> */}
          </section>
        </main>
      </section>
    </>
  )
}

export default EmployeesDetailsScreen